<mat-form-field appearance="outline">
  <mat-select
    id="transitProgramSelect-select-transitPrograms"
    placeholder="Transit Program"
    [formControl]="transitProgramSelector"
    multiple="{{ allowMultiSelect }}"
    [compareWith]="compareIds"
  >
    <mat-option>
      <ngx-mat-select-search
        id="transitProgramSelect-input-transitProgram"
        [formControl]="transitProgramFiltersControl"
        [placeholderLabel]="'Search...'"
        [noEntriesFoundLabel]="'No matching transit programs'"
      ></ngx-mat-select-search>
    </mat-option>
    <mat-option
      id="transitProgramSelect-option-{{ program.code }}"
      *ngFor="let program of filteredTransitPrograms | async"
      [value]="program"
    >
      {{ program.name }} ({{ program.code }})
    </mat-option>
  </mat-select>
</mat-form-field>
